var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "editor-text-options-view" }, [
    _c(
      "div",
      { staticClass: "main-options" },
      [
        _c("SelectComponent", {
          staticClass: "font-family-select",
          attrs: {
            "mobile-options-anchor": _vm.fontFamilyOptionsAnchor,
            "mobile-options-distance": 8,
            "option-styles": _vm.fontFamilyOptionStyles,
            options: _vm.fontModels,
            "options-theme": _vm.internalTheme,
            value: _vm.internalObjectModel.fontface,
            "item-title": "id",
            "item-value": "id",
            theme: "light",
          },
          on: { change: _vm.onFontFamilyChange, click: _vm.onFontFamilyClick },
        }),
        _c("divider", { staticClass: "divider full" }),
        _c(
          "ButtonToggleComponent",
          {
            ref: "fontSizeReference",
            staticClass: "font-size-button",
            attrs: { checked: _vm.isFontSizeActive, small: true },
            on: { click: _vm.onFontSizeClick },
          },
          [_vm._v(_vm._s(_vm.internalObjectModel.pointsize))]
        ),
        _c("divider", { staticClass: "divider full" }),
        _c(
          "ButtonToggleComponent",
          {
            ref: "colorPickerReference",
            staticClass: "color-picker-button",
            attrs: { checked: _vm.isColorPickerActive, small: true },
            on: { click: _vm.onColorPickerClick },
          },
          [
            _c("div", {
              staticClass: "circle",
              style: _vm.colorPickerCircleStyles,
            }),
          ]
        ),
        _c("divider", { staticClass: "divider full" }),
        _c(
          "ButtonToggleComponent",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.fontModelSelected.bold,
                expression: "fontModelSelected.bold",
              },
            ],
            attrs: { checked: !!_vm.internalObjectModel.fontbold, small: true },
            on: { click: _vm.onBoldClick },
          },
          [_c("IconComponent", [_vm._v("bold")])],
          1
        ),
        _c(
          "ButtonToggleComponent",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.fontModelSelected.italic,
                expression: "fontModelSelected.italic",
              },
            ],
            attrs: {
              checked: !!_vm.internalObjectModel.fontitalic,
              small: true,
            },
            on: { click: _vm.onItalicClick },
          },
          [_c("IconComponent", [_vm._v("italic")])],
          1
        ),
        _c(
          "ButtonToggleComponent",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.fontModelSelected.underline,
                expression: "fontModelSelected.underline",
              },
            ],
            attrs: {
              checked: !!_vm.internalObjectModel.fontunderline,
              small: true,
            },
            on: { click: _vm.onUnderlineClick },
          },
          [_c("IconComponent", [_vm._v("underline")])],
          1
        ),
        _c("divider", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.fontModelSelected.bold ||
                _vm.fontModelSelected.italic ||
                _vm.fontModelSelected.underline,
              expression:
                "\n\t\t\t\tfontModelSelected.bold\n\t\t\t\t|| fontModelSelected.italic\n\t\t\t\t|| fontModelSelected.underline\n\t\t\t",
            },
          ],
          staticClass: "divider full",
        }),
        !_vm.isSingleAlignmentButtonShow
          ? _c(
              "ButtonToggleGroupComponent",
              {
                attrs: { value: _vm.internalObjectModel.align },
                on: { change: _vm.onAlignChange },
              },
              [
                _c(
                  "ButtonToggleComponent",
                  {
                    staticClass: "text-align-button",
                    attrs: { small: true, name: "align", value: "Left" },
                  },
                  [_c("IconComponent", [_vm._v("left_alignment")])],
                  1
                ),
                _c(
                  "ButtonToggleComponent",
                  {
                    staticClass: "text-align-button",
                    attrs: { small: true, name: "align", value: "Center" },
                  },
                  [_c("IconComponent", [_vm._v("center_alignment")])],
                  1
                ),
                _c(
                  "ButtonToggleComponent",
                  {
                    staticClass: "text-align-button",
                    attrs: { small: true, name: "align", value: "Right" },
                  },
                  [_c("IconComponent", [_vm._v("right_alignment")])],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.isSingleAlignmentButtonShow
          ? _c(
              "ButtonToggleComponent",
              {
                staticClass: "text-align-button",
                attrs: { checked: _vm.isAlignActive, small: true },
                on: { click: _vm.onAlignClick },
              },
              [
                _vm.internalObjectModel.align === "Left"
                  ? _c("IconComponent", [_vm._v("left_alignment")])
                  : _vm._e(),
                _vm.internalObjectModel.align === "Center"
                  ? _c("IconComponent", [_vm._v("center_alignment")])
                  : _vm._e(),
                _vm.internalObjectModel.align === "Right"
                  ? _c("IconComponent", [_vm._v("right_alignment")])
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.isMobile &&
              (_vm.isColorPickerActive ||
                _vm.isFontFamilyActive ||
                _vm.isFontSizeActive ||
                _vm.isAlignActive),
            expression:
              "\n\t\t\tisMobile\n\t\t\t&& (\n\t\t\t\tisColorPickerActive\n\t\t\t\t|| isFontFamilyActive\n\t\t\t\t|| isFontSizeActive\n\t\t\t\t|| isAlignActive\n\t\t\t)\n\t\t",
          },
        ],
        ref: "subOptionsReference",
        staticClass: "sub-options",
        class: { "sub-options-font-family": _vm.isFontFamilyActive },
      },
      [
        _vm.isMobile && _vm.isColorPickerActive
          ? _c("ColorPickerTabsComponent", {
              attrs: {
                canvas: _vm.computedCanvas,
                value: _vm.internalObjectModel,
              },
              on: {
                change: _vm.onColorChange,
                "eye-dropper-end": _vm.onEyeDropperEnd,
                "eye-dropper-start": _vm.onEyeDropperStart,
              },
            })
          : _vm._e(),
        _vm.isMobile && _vm.isFontSizeActive
          ? _c("InputSliderComponent", {
              attrs: {
                min: _vm.offeringModel.minfontsize,
                "track-height": 8,
                value: _vm.internalObjectModel.pointsize,
              },
              on: { change: _vm.onFontSizeChange },
            })
          : _vm._e(),
        _vm.isMobile && _vm.isAlignActive
          ? _c(
              "ButtonToggleGroupComponent",
              {
                attrs: { value: _vm.internalObjectModel.align },
                on: { change: _vm.onAlignChange },
              },
              [
                _c(
                  "ButtonToggleComponent",
                  {
                    staticClass: "text-align-button",
                    attrs: { small: true, name: "align", value: "Left" },
                  },
                  [_c("IconComponent", [_vm._v("left_alignment")])],
                  1
                ),
                _c(
                  "ButtonToggleComponent",
                  {
                    staticClass: "text-align-button",
                    attrs: { small: true, name: "align", value: "Center" },
                  },
                  [_c("IconComponent", [_vm._v("center_alignment")])],
                  1
                ),
                _c(
                  "ButtonToggleComponent",
                  {
                    staticClass: "text-align-button",
                    attrs: { small: true, name: "align", value: "Right" },
                  },
                  [_c("IconComponent", [_vm._v("right_alignment")])],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }